"use client";

import { useState, useEffect } from "react";
import DocIssue from "public/doc-issue.svg";
import KinsaListContentWidget from "src/components/KinsaListContentWidget";
import { STATSIG_EVENTS } from "@repo/statsig";
import { handleManageSubscription } from "../actions";
import PRODUCT_NAME from "src/lib/product-name";

interface SubscriptionCancelledStateProps {
  className?: string;
}

const SubscriptionCancelledState: React.FC<SubscriptionCancelledStateProps> = ({
  className,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [portalUrl, setPortalUrl] = useState<string | null>(null);

  useEffect(() => {
    const prefetchPortalUrl = async () => {
      setIsLoading(true);
      try {
        const result = await handleManageSubscription();
        if ("error" in result) {
          console.error("Error prefetching portal URL:", result.error);
          return;
        }
        setPortalUrl(result.url);
      } catch (error) {
        console.error("Error prefetching portal URL:", error);
      } finally {
        setIsLoading(false);
      }
    };

    prefetchPortalUrl();
  }, []);

  return (
    <KinsaListContentWidget
      image={DocIssue}
      imageAlt="Subscription cancelled"
      headline="Subscription cancelled"
      body={`Reactivate now to restore full ${PRODUCT_NAME} access in seconds.`}
      href={portalUrl || undefined}
      actionButtonProps={{
        text: isLoading ? "LOADING..." : "REACTIVATE",
        eventData: { action: "sub_cancel_reactivate" },
        customEventName: STATSIG_EVENTS.SUB_CANCEL_REACTIVATE,
        className: "max-w-sm",
        disabled: isLoading || !portalUrl,
      }}
      className={className}
    />
  );
};

export default SubscriptionCancelledState;
